/* THE COUNTER — kit "Choose options" on the COLLECTION / SEARCH GRID (Sept 27 2026, founder: open
   under the card's row). Loaded by sections/counter-card-css.

   The panel is the same sections/counter-quick-add used by the cart and PDP bands (its CSS is
   injected by assets/counter-recs.js, which every page loads through counter-empty-cards.js).
   The grid needs its own placement, so this file owns it: the panel becomes a full-width grid
   item placed with CSS `order` right after the LAST card in the tapped card's visual row, so it
   opens under that row and pushes the next row down, like "+N" shades. Tap again, or the close
   button, to shut it; opening another closes the first.

   The wiring (pick every option, resolve the variant, add, open the drawer) mirrors
   counter-recs.js's wirePanel. Grid adds carry no Rebuy attribution: these are not Rebuy picks. */
(() => {
  if (window.__counterShelfKit) return;
  window.__counterShelfKit = true;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const theme = window.Shopify && Shopify.theme;
  const previewQs = theme && theme.role && theme.role !== 'main' && theme.id ? '&preview_theme_id=' + theme.id : '';
  const cache = new Map();
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const priceHtml = v => (v.c ? `<s class="crc__was">${esc(v.c)}</s> <span class="crc__now">${esc(v.p)}</span>` : esc(v.p));
  const load = h => {
    if (!cache.has(h)) cache.set(h, fetch(`${root}products/${encodeURIComponent(h)}?section_id=counter-quick-add${previewQs}`, { credentials: 'same-origin' })
      .then(r => (r.ok ? r.text() : '')).then(t => { const el = new DOMParser().parseFromString(t, 'text/html').querySelector('[data-cqa]'); return el ? el.outerHTML : ''; }).catch(() => ''));
    return cache.get(h);
  };
  const openDrawer = () => {
    const d = document.getElementById('cart-drawer');
    if (d && typeof d.show === 'function') { try { d.show(); return; } catch (e) {} }
    const o = document.querySelector('[aria-controls="cart-drawer"]');
    if (o) o.click();
  };
  const closeAll = () => document.querySelectorAll('[data-cs-grid] > [data-cqa]').forEach(p => { if (p._trigger) p._trigger.setAttribute('aria-expanded', 'false'); p.remove(); });
  const rowEnd = card => {
    const top = card.offsetTop;
    let last = card;
    card.parentElement.querySelectorAll(':scope > [data-crc], :scope > .cs-tile').forEach(el => {
      if (el.offsetParent && Math.abs(el.offsetTop - top) < 4) {
        const o = parseInt(getComputedStyle(el).order, 10) || 0;
        if (o > (parseInt(getComputedStyle(last).order, 10) || 0)) last = el;
      }
    });
    return parseInt(getComputedStyle(last).order, 10) || 0;
  };
  const wire = (panel, trigger) => {
    let vs = [];
    try { vs = JSON.parse(panel.querySelector('[data-cqa-variants]').textContent); } catch (e) {}
    const sets = [...panel.querySelectorAll('[data-cqa-option]')];
    const btn = panel.querySelector('[data-cqa-add]');
    const price = panel.querySelector('[data-cqa-price]');
    let current = null;
    const update = () => {
      const chosen = sets.map(s => { const r = s.querySelector('.cqa__radio:checked'); return r ? r.value : null; });
      sets.forEach((s, i) => { const l = s.querySelector('[data-cqa-chosen]'); if (l) l.textContent = chosen[i] ? ': ' + chosen[i] : ''; });
      const miss = sets.findIndex((s, i) => chosen[i] == null);
      current = miss === -1 ? vs.find(v => v.o.every((val, i) => val === chosen[i])) : null;
      if (miss !== -1) {
        const shade = sets[miss].dataset.shade === 'true' && sets.length === 1;
        btn.disabled = true; btn.textContent = shade ? 'Select shade' : 'Select ' + (sets[miss].querySelector('.cqa__label').firstChild.textContent || 'option').toLowerCase();
      } else if (!current) { btn.disabled = true; btn.textContent = 'Unavailable'; }
      else if (!current.a) { btn.disabled = true; btn.textContent = 'Sold out'; price.innerHTML = priceHtml(current); }
      else { btn.disabled = false; btn.textContent = 'Add to bag'; price.innerHTML = priceHtml(current); }
    };
    panel.addEventListener('change', update);
    panel.querySelector('[data-cqa-close]').addEventListener('click', () => { trigger.setAttribute('aria-expanded', 'false'); panel.remove(); trigger.focus(); });
    btn.addEventListener('click', async () => {
      if (!current || btn.disabled) return;
      btn.disabled = true; btn.textContent = 'Adding…';
      try {
        const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] }) });
        if (!r.ok) throw new Error('add ' + r.status);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        trigger.setAttribute('aria-expanded', 'false');
        panel.remove();
        openDrawer();
      } catch (e) { btn.disabled = false; btn.textContent = 'Try again'; }
    });
    update();
  };
  document.addEventListener('click', async e => {
    const trigger = e.target.closest('[data-cs-grid] .crc[data-case="kit"] a.crc__btn');
    if (!trigger) return;
    const card = trigger.closest('[data-crc]');
    const grid = card && card.parentElement;
    if (!card || !grid) return;
    e.preventDefault();
    e.stopPropagation();
    const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
    closeAll();
    if (wasOpen) return;
    trigger.setAttribute('aria-busy', 'true');
    const html = await load(card.dataset.handle);
    trigger.removeAttribute('aria-busy');
    if (!html) { location.href = trigger.getAttribute('href'); return; }
    const t = document.createElement('template'); t.innerHTML = html;
    const panel = t.content.firstElementChild;
    panel._trigger = trigger;
    panel.style.gridColumn = '1 / -1';
    panel.style.order = String(rowEnd(card) + 1);
    panel.style.margin = '0 0 40px';
    grid.appendChild(panel);
    trigger.setAttribute('aria-expanded', 'true');
    wire(panel, trigger);
    const first = panel.querySelector('.cqa__radio:not(:disabled)');
    if (first) first.focus({ preventScroll: true });
  }, true);
})();
